import {Alert} from "@cjdev-internal/visual-stack/lib/components/Alert";
import React from "react";

export const ErrorMessage = (setAlert, message) => <Alert type="warning" closeType="icon" onClose={() => {
  setAlert(false)
}}>
  There was an error loading the data!
  {message && <div>{message}</div>}
</Alert>;
